import { cEl } from '../../util';
import Icon from '../Common/Icon';

const OPTIMIZED_MIN_WIDTH = 1024;
let isNoticeDismissed = false;

function OptimizeNotice() {
    initialNotice();

    const viewportWidth = document.documentElement.clientWidth;
    if (viewportWidth < OPTIMIZED_MIN_WIDTH && !isNoticeDismissed) {
        const notice = cEl('div');
        notice.classList.add('optimized-notice');
        notice.append('본 서비스 화면은 데스크톱과 태블릿에 최적화되어 있습니다.');

        const closeButton = cEl('button');
        closeButton.append(Icon({ iconName: 'close' }));
        closeButton.addEventListener('click', e => {
            isNoticeDismissed = true;
            notice.classList.add('dismissed-notice');
            setTimeout(() => {
                document.body.removeChild(notice);
            }, 1000);
        });

        notice.append(closeButton);
        document.body.prepend(notice);
    }
}

const initialNotice = () => {
    const notice = document.querySelector('.optimized-notice');
    if (notice) {
        document.body.removeChild(notice);
    }
};

export default OptimizeNotice;
